import ContactForm from "@/components/base/ContactForm";
import ContactInfo from "@/components/base/ContactInfo";

export default function Formulaire() {
  return (
    <section id="devis" className="bg-brand-light py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-12 min-w-0">
          <ContactForm
            page="Moteur Profalux"
            subject="Nouveau lead Dépan'Volets — Moteur Profalux"
            title="Demandez votre devis gratuit"
            subtitle="Décrivez votre panne et nous vous recontactons sous 1 heure."
            variant="compact"
            showTitle
            placeholder="Décrivez votre panne de moteur Profalux..."
          />
          <ContactInfo variant="light" />
        </div>
      </div>
    </section>
  );
}